module.exports = __webpack_public_path__ + "static/media/figure-2b.193c1b10.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/faq/change-batteries/figure-2b.jpg
// module id = 1202
// module chunks = 0